import { CreationTime } from "@/components/CreationTime";
import { Text } from "@/components/podkit/typography/Text";
import type { PlainRunner } from "@/queries/runner-queries";
import type { FC } from "react";

export const RunnerCreatedAt: FC<{ runner: PlainRunner }> = ({ runner }) => {
    return (
        <Text className="text-sm text-content-primary">
            Created <CreationTime timestamp={runner.createdAt} />
        </Text>
    );
};
